// @flow
import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { isBrowser } from 'utils/browser';
import { setGMapsError } from '../redux/main/actions/gMapsError';

type Props = {
  setGMapsError: Function
};

class SetGMapsError extends React.PureComponent<Props> {
  componentDidMount() {
    if (isBrowser()) {
      window.Idealist = window.Idealist || {};
      window.Idealist.setGMapsError = errorType => {
        this.props.setGMapsError(errorType);
      };
    }
    if (Array.isArray(window.Idealist.gmapsErrors)) {
      window.Idealist.gmapsErrors.forEach(errorType => {
        window.Idealist.setGMapsError(errorType);
      });
    }
  }

  render() {
    return null;
  }
}

export default withRouter(
  connect(
    null,
    {
      setGMapsError
    }
  )(SetGMapsError)
);
